"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withExperiment = _interopRequireDefault(require("./withExperiment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DefaultComponent = () => null;

/** High order component, decides what component to show depending on the variant.
 *
 * @param {String} experiment - Experiment name
 * @param {Object} variants - Key is variant, value is the react component for that variant. The `else` keyword is used when no variant has matched (e.g.: test discovery)
 * @return {ReactComponent} Component to be used
 */
function withVariants(experiment, variants) {
  function WithVariants(props) {
    const Component = variants[props.variant] || variants.else || DefaultComponent;
    return /*#__PURE__*/_react.default.createElement(Component, props);
  }
  WithVariants.displayName = `withVariants(${experiment})`;
  WithVariants.propTypes = {
    variant: _propTypes.default.string
  };
  return (0, _withExperiment.default)(experiment)(WithVariants);
}
var _default = withVariants;
exports.default = _default;